import { createElement } from '@gn-audio/core/common//templating';
import { emulateClickWhenEnterOrSpacePressed } from '../../../../utilities';
import { getEcomDomains, getSiteContext, getSiteContextName, getUserCountryCode, } from '../../utilities';
import './ecom-domain-list.component.scss';
import template from './ecom-domain-list.component.html';
var EcomDomainListComponent = /** @class */ (function () {
    function EcomDomainListComponent() {
        var _this = this;
        this.siteContext = getSiteContext();
        this.siteContextName = getSiteContextName(this.siteContext);
        this.show = function () {
            var _a, _b;
            (_a = _this.overlay) === null || _a === void 0 ? void 0 : _a.classList.add("visible" /* CssClass.Visible */);
            (_b = _this.list) === null || _b === void 0 ? void 0 : _b.classList.add("visible" /* CssClass.Visible */);
        };
        this.hide = function () {
            var _a, _b;
            (_a = _this.overlay) === null || _a === void 0 ? void 0 : _a.classList.remove("visible" /* CssClass.Visible */);
            (_b = _this.list) === null || _b === void 0 ? void 0 : _b.classList.remove("visible" /* CssClass.Visible */);
        };
        this.toggle = function () {
            var _a;
            ((_a = _this.overlay) === null || _a === void 0 ? void 0 : _a.classList.contains("visible" /* CssClass.Visible */)) ? _this.hide() : _this.show();
        };
        this.handleKeysPressesOnList = function (event) {
            if (event.code === "Enter" /* KeyboardCode.Enter */ || event.code === "Space" /* KeyboardCode.Space */) {
                // Trigger the function explicitly to correctly pass target of event
                _this.onDomainSelect(event);
            }
        };
        this.handleKeysPressesOnElement = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.element);
        };
        this.onDomainSelect = function (event) {
            var target = event.target;
            var targetDomainCode = target.dataset.domainCode;
            var targetDomain = getEcomDomains().find(function (x) { return (x.code === targetDomainCode); });
            _this.selected.innerHTML = "".concat(_this.siteContextName, " ").concat(targetDomain.name);
            _this.selected.dataset.domainCode = targetDomain.code;
            _this.onEcomDomainChange(targetDomain);
        };
    }
    EcomDomainListComponent.prototype.render = function (container, onEcomDomainChange) {
        this.onEcomDomainChange = onEcomDomainChange;
        this.element = container.appendChild(createElement(template, {}));
        this.element.addEventListener('click', this.toggle);
        this.element.addEventListener('keydown', this.handleKeysPressesOnElement);
        var userCountryCode = getUserCountryCode();
        var userEcomDomain = getEcomDomains().find(function (x) { return x.code === userCountryCode; });
        this.selected = this.element.querySelector('.ecom-domain-list__item--current');
        this.selected.innerHTML = "".concat(this.siteContextName, " ").concat(userEcomDomain.name);
        this.selected.dataset.countryCode = userEcomDomain.code;
        this.list = this.element.querySelector('.ecom-domain-list__items');
        this.list.addEventListener('click', this.onDomainSelect);
        this.list.addEventListener('keydown', this.handleKeysPressesOnList);
        for (var _i = 0, _a = getEcomDomains(); _i < _a.length; _i++) {
            var ecomDomain = _a[_i];
            var listItem = document.createElement('li');
            listItem.dataset.domainCode = ecomDomain.code;
            listItem.tabIndex = 0;
            listItem.classList.add('ecom-domain-list__item');
            listItem.innerHTML = "".concat(this.siteContextName, " ").concat(ecomDomain.name);
            this.list.appendChild(listItem);
        }
        this.overlay = document.createElement('div');
        this.overlay.classList.add('ecom-domain-list-overlay');
        container.appendChild(this.overlay);
        this.overlay.addEventListener('click', this.hide);
        // Notify others that default ecom domain is set.
        this.onEcomDomainChange(userEcomDomain);
    };
    EcomDomainListComponent.prototype.destroy = function () {
        var _a, _b, _c, _d;
        (_a = this.list) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.onDomainSelect);
        (_b = this.list) === null || _b === void 0 ? void 0 : _b.removeEventListener('keydown', this.handleKeysPressesOnList);
        this.overlay.removeEventListener('click', this.hide);
        (_c = this.overlay) === null || _c === void 0 ? void 0 : _c.remove();
        this.element.removeEventListener('click', this.toggle);
        this.element.removeEventListener('keydown', this.handleKeysPressesOnElement);
        (_d = this.element) === null || _d === void 0 ? void 0 : _d.remove();
    };
    return EcomDomainListComponent;
}());
export { EcomDomainListComponent };
